import { z } from "zod";

export const ShareReadyMessage = z.object({
    type: z.enum(["booking.ready", "proposal.ready"]),
    title: z.string().trim().min(1).optional(),
});
export type ShareReadyMessage = z.infer<typeof ShareReadyMessage>;

export function parseShareReadyMessage(data: unknown): ShareReadyMessage | null {
    const parsed = ShareReadyMessage.safeParse(data);
    return parsed.success ? parsed.data : null;
}
